module.exports = __webpack_public_path__ + "img/gift11.2f140143.png";